/*
  Note: This file makes use of PascalCase naming convention for all Interfaces and Enums to commply
  with required use / alignment with GraphQL query & mutation inputs and responses which are case sensitive.
  This is a known deviation from the convention of using CamelCase for interfaces.
*/
export interface Notification {
  Id: string;
  Title: string;
  Description: string;
  Category: string;
  StartTime: string;
  EndTime: string;
  Severity: NotificationSeverity;
  Type: NotificationType;
}
export enum NotificationSeverity {
  Info = 'Info',
  Warning = 'Warning',
  Critical = 'Critical'
}

export enum NotificationType {
  Announcement = 'ANNOUNCEMENT',
  Banner = 'BANNER'
}


export interface getNotificationInput {
  AnnKey: string;
  Active: boolean;
  Type?: NotificationType;
}
